const PLACEHOLDER = '##ecologi';
const ECOLOGI_URL = 'https://public.ecologi.com/users/posieandpenn/trees';
const CACHE_KEY = 'el-tree-count';
const CACHE_TIMESTAMP_KEY = 'el-last-checked-tree-count-timestamp';
const CACHE_DURATION = 120 * 60 * 1000;

export const replaceTreeCount = (treeCountString, root = document.body) => {
  if (!root || !root.textContent.includes(PLACEHOLDER)) {
    return;
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (node.nodeValue.includes(PLACEHOLDER)) {
      node.nodeValue = node.nodeValue.replaceAll(PLACEHOLDER, treeCountString);
    }
  }
};

const fetchTreeCount = async () => {
  const cachedTreeCount = localStorage.getItem(CACHE_KEY);
  const lastChecked = parseInt(localStorage.getItem(CACHE_TIMESTAMP_KEY), 10);
  if (cachedTreeCount && lastChecked && Date.now() < lastChecked + CACHE_DURATION) {
    return cachedTreeCount;
  }

  try {
    const data = await (await fetch(ECOLOGI_URL)).json();
    if (!Number.isInteger(data?.total)) {
      throw new Error(`Invalid data received from Ecologi: ${JSON.stringify(data)}`);
    }
    const formattedTotalTrees = data.total.toLocaleString('en-GB');
    localStorage.setItem(CACHE_KEY, formattedTotalTrees);
    localStorage.setItem(CACHE_TIMESTAMP_KEY, Date.now());
    return formattedTotalTrees;
  } catch (error) {
    console.error(error);
    return cachedTreeCount;
  }
};

export const initialiseEcologiTreeCount = async () => {
  const cachedTreeCount = localStorage.getItem(CACHE_KEY);
  if (cachedTreeCount) {
    replaceTreeCount(cachedTreeCount);
  }

  const treeCount = await fetchTreeCount();
  if (!treeCount) {
    return;
  }

  replaceTreeCount(treeCount);

  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          replaceTreeCount(treeCount, node);
        } else if (node.nodeType === Node.TEXT_NODE && node.nodeValue.includes(PLACEHOLDER)) {
          node.nodeValue = node.nodeValue.replaceAll(PLACEHOLDER, treeCount);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
};
